export default __webpack_public_path__ + "static/offroad-01d63a641ba5ead3629e878ceb5bf285.png";